import { IResponseBase } from "./app";
import { IServiceTodo } from "./service-todo";
import { IServiceDone } from "./service-done";

export enum ColorType {
  Gloss = 0,
  Satin = 10,
}

export enum TransferStatus {
  NotTransferred = 0,
  Transferred = 1,
  Success = 7,
  Error = 13,
}

export interface ITransferStatusList {
  value: TransferStatus;
  text: string;
}

export const TRANSFER_STATUS_LIST: ITransferStatusList[] = [
  // {
  //   value: 0,
  //   text: "NotTransferred"
  // },
  {
    value: 1,
    text: "Transferred",
  },
  {
    value: 7,
    text: "Success",
  },
  {
    value: 13,
    text: "Error",
  },
];

export interface IWorkOrder {
  RecordID?: number;
  CustomerID: number;
  InvoiceNum: string;
  Price?: number;
  Deadline?: string;
  CreatedBy?: number;
  DateCreated?: string;
  Year?: number;
  Make: string;
  Model: string;
  Last8Vin: string;
  CarColor: string;
  RimRepairs?: number;
  LF?: boolean;
  RF?: boolean;
  LB?: boolean;
  RB?: boolean;
  WheelLock: boolean;
  WheelColorType?: ColorType;
  WheelColor: string;
  CaliperColor: string;
  Decals?: boolean;
  DecalDesc: string;
  RepairDescription: string;
  SentBy?: number;
  SentTo?: number;
  TransferStatus?: TransferStatus;
  Completed?: boolean;
  CompletedOn?: string;
	LVM?: boolean;
}

export interface IWorkOrderCard {
  RecordID: number;
  Deadline?: string;
  CustID?: number;
  CustName: string;
	CustEmail: string;
	CustPhone: string;
  // CustLName: string;
  Year: string;
  Make: string;
  Model: string;
  Last8Vin: string;
  RepairDesc: string;
  TransferStatus: TransferStatus;
  SentBy?: number;
  SentTo?: number;
  TransferMemo: string;
  ServicesToDo: string;
  ServicesDone: string;
  Priority: number;
  IsCompleted: boolean;
	LVM: boolean;
}

export interface ITransfer {
  RecordID?: number;
  OrderID: number;
  SentBy: number;
  SentTo: number;
  TransferStatus: TransferStatus;
  TransferDate: string;
  Memo: string;
}

export interface IInsertWorkOrderRequest {
  WorkOrder: IWorkOrder;
  Services: IServiceTodo[];
}

export interface IInsertWorkOrderReponse extends IResponseBase {
  NewWorkOrder: IWorkOrderCard;
}


export interface ILeftVoiceMailRequest {
	WorkOrderID: number;
	LVM: boolean;
}

export interface ILeftVoiceMailReponse extends IResponseBase {
}



export interface IUpdateWorkOrderOfficeRequest {
  WorkOrder: IWorkOrder;
  Services: IServiceTodo[];
}

export interface IUpdateWorkOrderOfficeReponse extends IResponseBase {
  NewWorkOrder: IWorkOrderCard;
}

export interface IUpdateWorkOrderTechRequest {
  WorkOrderID: number;
  Services: IServiceTodo[];
}

export interface IUpdateWorkOrderTechReponse extends IResponseBase {}

export interface IGetWorkOrderRequest {
  WorkOrderID: number;
}

export interface IGetWorkOrderResponse extends IResponseBase {
  WorkOrder: IWorkOrder;
  ServicesToDo: IServiceTodo[];
  ServicesDone: IServiceDone[];
}

export interface IWorkOrderFilter {
  WorkOrderID?: number;
  SentBy?: number;
  SentTo?: number;
  Completed?: boolean;
  DeadlineMin?: Date;
  DeadlineMax?: Date;
  TransferStatus?: number;
  CustomerID?: number;
  Keyword?: string;
}

export interface IGetWorkOrdersListRequest {
  Filter?: IWorkOrderFilter;
}

export interface IGetWorkOrdersListResponse extends IResponseBase {
  WorkOrders: IWorkOrderCard[];
}

export interface ITransferWorkOrderRequest {
  WorkOrderID: number;
  TargetUserID: number;
  Memo: string;
  Status: TransferStatus;
}

export interface ITransferWorkOrderResponse extends IResponseBase {}

export interface ISetWorkOrderStatusRequest {
  WorkOrderID: number;
  IsCompleted: boolean;
  Memo: string;
}

export interface ISetWorkOrderStatusResponse extends IResponseBase {}
